import React from 'react';
import '../../assets/css/loader.css';

const Loader: React.FC = () => {
 return (
   <>
     <section className="dots-container d-flex justify-content-center align-items-center vh-100">
       <div className="dot"></div>
       <div className="dot"></div>
       <div className="dot"></div>
       <div className="dot"></div>
       <div className="dot"></div>
     </section>
   </>
 )
}
export default Loader